import { SegmentedControls } from "@portal/components/primitives";
import { type EntityScope, SCOPE_OPTIONS } from "./scope";

type ScopeSelectorProps = {
	value: EntityScope;
	onChange: (scope: EntityScope) => void;
	testId?: string;
};

export const ScopeSelector = ({ value, onChange, testId }: ScopeSelectorProps) => (
	<SegmentedControls<EntityScope>
		value={value}
		onChange={onChange}
		data-testid={testId}
		trackingId="scope-selector"
	>
		{SCOPE_OPTIONS.map((option) => (
			<SegmentedControls.Segment
				key={option.id}
				value={option.id}
				trackingId={`scope-selector-${option.id}`}
			>
				{option.label}
			</SegmentedControls.Segment>
		))}
	</SegmentedControls>
);
